import { Eye, EyeOff } from 'lucide-react';

interface PrivacyToggleProps {
  value: boolean;
  onChange: (v: boolean) => void;
}

export default function PrivacyToggle({ value, onChange }: PrivacyToggleProps) {
  return (
    <button
      type="button"
      className="ml-2 p-2 rounded hover:bg-gray-100 transition-colors"
      onClick={() => onChange(!value)}
      aria-label={value ? 'Hide from public' : 'Show on public profile'}
    >
      {value ? (
        <Eye className="text-primary" />
      ) : (
        <EyeOff className="text-muted-foreground" />
      )}
    </button>
  );
}
